import { Alert } from '../types/alert'
import { getNameOrMail } from '../helpers'
import {
	BG_BY_MEASURE_TYPE,
	BgByMeasureTypeItem,
} from '../constants/clinicalBgPageConstants'
import { useTypedSelector } from './useTypedSelector'
import { SYSTEM_BG_ICON_TYPES } from '../types/systemEvent'
import { useTimeController } from '@app/hooks/contexts/timeController/TimeControllerContext'
import { selectPatientBGUnits } from '../store/reducers/patientOverview/darioSystemData/selectors'

interface UseBgAlert {
	eventTypeBgData: BgByMeasureTypeItem | undefined
	iconType: SYSTEM_BG_ICON_TYPES
	glucoseValue: number
	measureUnitLabel: string
	eventTime: string
	name: string
}

export const useBgAlert = (alert: Alert): UseBgAlert => {
	const {
		formatters: { tdf3 },
	} = useTimeController()
	const bgUnits = useTypedSelector(selectPatientBGUnits)
	const eventTypeBgData = BG_BY_MEASURE_TYPE.find(
		item => item.id === alert.headers?.last_measure_range
	)
	const mState =
		alert.headers?.last_measure_range?.toUpperCase() as keyof typeof SYSTEM_BG_ICON_TYPES

	const iconType = SYSTEM_BG_ICON_TYPES[mState]

	const glucoseValue =
		bgUnits === 'mgdl'
			? +(alert.headers.last_glucose_measure || 0) * 18
			: +(alert.headers.last_glucose_measure || 0)

	const measureUnitLabel = bgUnits === 'mgdl' ? 'mg/dl' : 'mmol/L'

	const eventTime = tdf3(alert.op?.addedTimestamp)

	const name = getNameOrMail(
		alert.patientData?.firstName || '',
		alert.patientData?.lastName || '',
		alert.patientData?.email
	)

	return {
		eventTypeBgData,
		iconType,
		glucoseValue,
		measureUnitLabel,
		eventTime,
		name,
	}
}
